import { render, staticRenderFns } from "./GuidelineChat.vue?vue&type=template&id=4ca59c68&scoped=true&"
import script from "./GuidelineChat.vue?vue&type=script&lang=ts&"
export * from "./GuidelineChat.vue?vue&type=script&lang=ts&"
import style0 from "./GuidelineChat.vue?vue&type=style&index=0&id=4ca59c68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca59c68",
  null
  
)

export default component.exports